/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateInquiryRequestDto } from '../models';
// @ts-ignore
import type { CreateProcessRequestDto } from '../models';
// @ts-ignore
import type { InquiryCreatedDto } from '../models';
// @ts-ignore
import type { ProcessAttentionPageableResponseDto } from '../models';
// @ts-ignore
import type { ProcessAttentionScopeDto } from '../models';
// @ts-ignore
import type { ProcessAttentionSortByDto } from '../models';
// @ts-ignore
import type { ProcessCreationAiNoteRequestDto } from '../models';
// @ts-ignore
import type { ProcessCreationAiSuggestionsDto } from '../models';
// @ts-ignore
import type { ProcessCreationDefaultDataDto } from '../models';
// @ts-ignore
import type { ProcessCreationResponseDto } from '../models';
// @ts-ignore
import type { ProcessDto } from '../models';
// @ts-ignore
import type { ProcessPageableResponseDto } from '../models';
// @ts-ignore
import type { ProcessSearchRequestDto } from '../models';
// @ts-ignore
import type { ProcessShortDetailsDto } from '../models';
// @ts-ignore
import type { ProcessTodoInfoDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
// @ts-ignore
import type { TaskDefinitionDto } from '../models';
// @ts-ignore
import type { UpdateProcessRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessStatusRequestDto } from '../models';
/**
 * RestProcessesApi - axios parameter creator
 */
export const RestProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Skrót dla obsługi zapytania: zamiast zakładać osobno proces, grupę ofert i ofertę, tworzy wszystkie trzy w jednej transakcji i zwraca gotową ofertę. Gdy podany jest `sourceOfferId`, oferta powstaje jako kopia wskazanego szablonu wraz z całą strukturą; bez niego jest pusta. 
         * @summary Start an inquiry — process, offer group and offer in one call
         * @param {string} userId 
         * @param {CreateInquiryRequestDto} createInquiryRequestDto Klient, termin i liczba gości — reszta domyślna
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInquiry: async (userId: string, createInquiryRequestDto: CreateInquiryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createInquiry', 'userId', userId)
            // verify required parameter 'createInquiryRequestDto' is not null or undefined
            assertParamExists('createInquiry', 'createInquiryRequestDto', createInquiryRequestDto)
            const localVarPath = `/api/processes/inquiry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInquiryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcess: async (createProcessRequestDto: CreateProcessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProcessRequestDto' is not null or undefined
            assertParamExists('createProcess', 'createProcessRequestDto', createProcessRequestDto)
            const localVarPath = `/api/processes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProcessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcess: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcess', 'processId', processId)
            const localVarPath = `/api/processes/{processId}`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jednym wywołaniem modelu wyciąga z wątku wszystko, czego potrzebuje kreator procesu: nazwy, dane klienta i kontaktu, opis oraz szkic odpowiedzi. 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationAiSuggestions: async (emailThreadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailThreadId' is not null or undefined
            assertParamExists('getProcessCreationAiSuggestions', 'emailThreadId', emailThreadId)
            const localVarPath = `/api/processes/creation-ai-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (emailThreadId !== undefined) {
                localVarQueryParameter['emailThreadId'] = emailThreadId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Podpowiedzi z maili podpiętych do istniejącego procesu, żeby uzupełnić jego klienta i kontakt. Proces bez podpiętych wątków to kod 400. 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationAiSuggestionsForProcess: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessCreationAiSuggestionsForProcess', 'processId', processId)
            const localVarPath = `/api/processes/{processId}/creation-ai-suggestions`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Te same podpowiedzi co dla wątku mailowego, ale z notatki handlowca — np. z rozmowy telefonicznej, gdy proces nie ma jeszcze maila. Pusta notatka to kod 400. 
         * @param {ProcessCreationAiNoteRequestDto} processCreationAiNoteRequestDto Notatka handlowca, z której AI wyciąga dane klienta, kontaktu i wydarzenia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationAiSuggestionsFromNote: async (processCreationAiNoteRequestDto: ProcessCreationAiNoteRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processCreationAiNoteRequestDto' is not null or undefined
            assertParamExists('getProcessCreationAiSuggestionsFromNote', 'processCreationAiNoteRequestDto', processCreationAiNoteRequestDto)
            const localVarPath = `/api/processes/creation-ai-suggestions/note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processCreationAiNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [emailThreadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationDefaultData: async (email: string, emailThreadId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getProcessCreationDefaultData', 'email', email)
            const localVarPath = `/api/processes/default-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (emailThreadId !== undefined) {
                localVarQueryParameter['emailThreadId'] = emailThreadId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessTodoInfo: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessTodoInfo', 'processId', processId)
            const localVarPath = `/api/processes/{processId}/todo`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessesShortList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/processes/short`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcesses: async (page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchProcesses', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchProcesses', 'pageSize', pageSize)
            // verify required parameter 'processSearchRequestDto' is not null or undefined
            assertParamExists('searchProcesses', 'processSearchRequestDto', processSearchRequestDto)
            const localVarPath = `/api/processes/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca procesy, ktorych jestem wlascicielem i pod ktorymi wisi moje otwarte zadanie, wraz z agregatem tych zadan: ile ich jest, jaki jest najblizszy termin i jakich sa rodzajow. Domyslny `scope=DUE` odpowiada 1:1 staremu filtrowi `isNeedingAttention` z `processes-search`, wiec podmiana na pulpicie niczego nie zmienia w doborze wierszy — dokłada tylko informacje, ktorych ten widok wczesniej nie mial.  `summary` liczy sie zawsze na pelnym zbiorze (bez `scope` i `definitions`), zeby liczniki przy filtrach pokazywaly, ile jest do wziecia, a nie ile zostalo po odfiltrowaniu. 
         * @summary Kolejka pracy pulpitu — procesy z moimi otwartymi zadaniami
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {ProcessAttentionScopeDto} [scope] Wycinek terminow. Domyslnie DUE — zaleglosci i dzisiaj, czyli stare zachowanie.
         * @param {Array<TaskDefinitionDto>} [definitions] Zawez do procesow, pod ktorymi wisi zadanie ktoregos z tych rodzajow.
         * @param {ProcessAttentionSortByDto} [sortBy] Domyslnie NEAREST_DUE_DATE rosnaco — najstarsze nieobsluzone na gorze.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcessesNeedingAttention: async (page: number, pageSize: number, userId: string, scope?: ProcessAttentionScopeDto, definitions?: Array<TaskDefinitionDto>, sortBy?: ProcessAttentionSortByDto, sortOrder?: SortDirectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchProcessesNeedingAttention', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchProcessesNeedingAttention', 'pageSize', pageSize)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('searchProcessesNeedingAttention', 'userId', userId)
            const localVarPath = `/api/processes/needing-attention`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (definitions) {
                localVarQueryParameter['definitions'] = definitions.join(COLLECTION_FORMATS.csv);
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcess: async (processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcess', 'processId', processId)
            // verify required parameter 'updateProcessRequestDto' is not null or undefined
            assertParamExists('updateProcess', 'updateProcessRequestDto', updateProcessRequestDto)
            const localVarPath = `/api/processes/{processId}`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process\'s status
         * @param {string} processId 
         * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessStatus: async (processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessStatus', 'processId', processId)
            // verify required parameter 'updateProcessStatusRequestDto' is not null or undefined
            assertParamExists('updateProcessStatus', 'updateProcessStatusRequestDto', updateProcessStatusRequestDto)
            const localVarPath = `/api/processes/{processId}/status`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessesApi - functional programming interface
 */
export const RestProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * Skrót dla obsługi zapytania: zamiast zakładać osobno proces, grupę ofert i ofertę, tworzy wszystkie trzy w jednej transakcji i zwraca gotową ofertę. Gdy podany jest `sourceOfferId`, oferta powstaje jako kopia wskazanego szablonu wraz z całą strukturą; bez niego jest pusta. 
         * @summary Start an inquiry — process, offer group and offer in one call
         * @param {string} userId 
         * @param {CreateInquiryRequestDto} createInquiryRequestDto Klient, termin i liczba gości — reszta domyślna
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInquiry(userId: string, createInquiryRequestDto: CreateInquiryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InquiryCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInquiry(userId, createInquiryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.createInquiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcess(createProcessRequestDto: CreateProcessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcess(createProcessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.createProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcess(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcess(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jednym wywołaniem modelu wyciąga z wątku wszystko, czego potrzebuje kreator procesu: nazwy, dane klienta i kontaktu, opis oraz szkic odpowiedzi. 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCreationAiSuggestions(emailThreadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessCreationAiSuggestionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCreationAiSuggestions(emailThreadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessCreationAiSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Podpowiedzi z maili podpiętych do istniejącego procesu, żeby uzupełnić jego klienta i kontakt. Proces bez podpiętych wątków to kod 400. 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCreationAiSuggestionsForProcess(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessCreationAiSuggestionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCreationAiSuggestionsForProcess(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessCreationAiSuggestionsForProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Te same podpowiedzi co dla wątku mailowego, ale z notatki handlowca — np. z rozmowy telefonicznej, gdy proces nie ma jeszcze maila. Pusta notatka to kod 400. 
         * @param {ProcessCreationAiNoteRequestDto} processCreationAiNoteRequestDto Notatka handlowca, z której AI wyciąga dane klienta, kontaktu i wydarzenia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCreationAiSuggestionsFromNote(processCreationAiNoteRequestDto: ProcessCreationAiNoteRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessCreationAiSuggestionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCreationAiSuggestionsFromNote(processCreationAiNoteRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessCreationAiSuggestionsFromNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [emailThreadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCreationDefaultData(email: string, emailThreadId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessCreationDefaultDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCreationDefaultData(email, emailThreadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessCreationDefaultData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessTodoInfo(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessTodoInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessTodoInfo(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessTodoInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessesShortList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessShortDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessesShortList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessesShortList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProcesses(page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProcesses(page, pageSize, processSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.searchProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca procesy, ktorych jestem wlascicielem i pod ktorymi wisi moje otwarte zadanie, wraz z agregatem tych zadan: ile ich jest, jaki jest najblizszy termin i jakich sa rodzajow. Domyslny `scope=DUE` odpowiada 1:1 staremu filtrowi `isNeedingAttention` z `processes-search`, wiec podmiana na pulpicie niczego nie zmienia w doborze wierszy — dokłada tylko informacje, ktorych ten widok wczesniej nie mial.  `summary` liczy sie zawsze na pelnym zbiorze (bez `scope` i `definitions`), zeby liczniki przy filtrach pokazywaly, ile jest do wziecia, a nie ile zostalo po odfiltrowaniu. 
         * @summary Kolejka pracy pulpitu — procesy z moimi otwartymi zadaniami
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {ProcessAttentionScopeDto} [scope] Wycinek terminow. Domyslnie DUE — zaleglosci i dzisiaj, czyli stare zachowanie.
         * @param {Array<TaskDefinitionDto>} [definitions] Zawez do procesow, pod ktorymi wisi zadanie ktoregos z tych rodzajow.
         * @param {ProcessAttentionSortByDto} [sortBy] Domyslnie NEAREST_DUE_DATE rosnaco — najstarsze nieobsluzone na gorze.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProcessesNeedingAttention(page: number, pageSize: number, userId: string, scope?: ProcessAttentionScopeDto, definitions?: Array<TaskDefinitionDto>, sortBy?: ProcessAttentionSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessAttentionPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProcessesNeedingAttention(page, pageSize, userId, scope, definitions, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.searchProcessesNeedingAttention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcess(processId, updateProcessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.updateProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process\'s status
         * @param {string} processId 
         * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessStatus(processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessStatus(processId, updateProcessStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.updateProcessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessesApi - factory interface
 */
export const RestProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessesApiFp(configuration)
    return {
        /**
         * Skrót dla obsługi zapytania: zamiast zakładać osobno proces, grupę ofert i ofertę, tworzy wszystkie trzy w jednej transakcji i zwraca gotową ofertę. Gdy podany jest `sourceOfferId`, oferta powstaje jako kopia wskazanego szablonu wraz z całą strukturą; bez niego jest pusta. 
         * @summary Start an inquiry — process, offer group and offer in one call
         * @param {string} userId 
         * @param {CreateInquiryRequestDto} createInquiryRequestDto Klient, termin i liczba gości — reszta domyślna
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInquiry(userId: string, createInquiryRequestDto: CreateInquiryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<InquiryCreatedDto> {
            return localVarFp.createInquiry(userId, createInquiryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcess(createProcessRequestDto: CreateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationResponseDto> {
            return localVarFp.createProcess(createProcessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDto> {
            return localVarFp.getProcess(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Jednym wywołaniem modelu wyciąga z wątku wszystko, czego potrzebuje kreator procesu: nazwy, dane klienta i kontaktu, opis oraz szkic odpowiedzi. 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationAiSuggestions(emailThreadId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationAiSuggestionsDto> {
            return localVarFp.getProcessCreationAiSuggestions(emailThreadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Podpowiedzi z maili podpiętych do istniejącego procesu, żeby uzupełnić jego klienta i kontakt. Proces bez podpiętych wątków to kod 400. 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationAiSuggestionsForProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationAiSuggestionsDto> {
            return localVarFp.getProcessCreationAiSuggestionsForProcess(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Te same podpowiedzi co dla wątku mailowego, ale z notatki handlowca — np. z rozmowy telefonicznej, gdy proces nie ma jeszcze maila. Pusta notatka to kod 400. 
         * @param {ProcessCreationAiNoteRequestDto} processCreationAiNoteRequestDto Notatka handlowca, z której AI wyciąga dane klienta, kontaktu i wydarzenia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationAiSuggestionsFromNote(processCreationAiNoteRequestDto: ProcessCreationAiNoteRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationAiSuggestionsDto> {
            return localVarFp.getProcessCreationAiSuggestionsFromNote(processCreationAiNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [emailThreadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationDefaultData(email: string, emailThreadId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationDefaultDataDto> {
            return localVarFp.getProcessCreationDefaultData(email, emailThreadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessTodoInfo(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessTodoInfoDto> {
            return localVarFp.getProcessTodoInfo(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessesShortList(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessShortDetailsDto>> {
            return localVarFp.getProcessesShortList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcesses(page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessPageableResponseDto> {
            return localVarFp.searchProcesses(page, pageSize, processSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca procesy, ktorych jestem wlascicielem i pod ktorymi wisi moje otwarte zadanie, wraz z agregatem tych zadan: ile ich jest, jaki jest najblizszy termin i jakich sa rodzajow. Domyslny `scope=DUE` odpowiada 1:1 staremu filtrowi `isNeedingAttention` z `processes-search`, wiec podmiana na pulpicie niczego nie zmienia w doborze wierszy — dokłada tylko informacje, ktorych ten widok wczesniej nie mial.  `summary` liczy sie zawsze na pelnym zbiorze (bez `scope` i `definitions`), zeby liczniki przy filtrach pokazywaly, ile jest do wziecia, a nie ile zostalo po odfiltrowaniu. 
         * @summary Kolejka pracy pulpitu — procesy z moimi otwartymi zadaniami
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} userId 
         * @param {ProcessAttentionScopeDto} [scope] Wycinek terminow. Domyslnie DUE — zaleglosci i dzisiaj, czyli stare zachowanie.
         * @param {Array<TaskDefinitionDto>} [definitions] Zawez do procesow, pod ktorymi wisi zadanie ktoregos z tych rodzajow.
         * @param {ProcessAttentionSortByDto} [sortBy] Domyslnie NEAREST_DUE_DATE rosnaco — najstarsze nieobsluzone na gorze.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcessesNeedingAttention(page: number, pageSize: number, userId: string, scope?: ProcessAttentionScopeDto, definitions?: Array<TaskDefinitionDto>, sortBy?: ProcessAttentionSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessAttentionPageableResponseDto> {
            return localVarFp.searchProcessesNeedingAttention(page, pageSize, userId, scope, definitions, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcess(processId, updateProcessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process\'s status
         * @param {string} processId 
         * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessStatus(processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessStatus(processId, updateProcessStatusRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessesApi - interface
 */
export interface RestProcessesApiInterface {
    /**
     * Skrót dla obsługi zapytania: zamiast zakładać osobno proces, grupę ofert i ofertę, tworzy wszystkie trzy w jednej transakcji i zwraca gotową ofertę. Gdy podany jest `sourceOfferId`, oferta powstaje jako kopia wskazanego szablonu wraz z całą strukturą; bez niego jest pusta. 
     * @summary Start an inquiry — process, offer group and offer in one call
     * @param {string} userId 
     * @param {CreateInquiryRequestDto} createInquiryRequestDto Klient, termin i liczba gości — reszta domyślna
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInquiry(userId: string, createInquiryRequestDto: CreateInquiryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<InquiryCreatedDto>;

    /**
     * 
     * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProcess(createProcessRequestDto: CreateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationResponseDto>;

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDto>;

    /**
     * Jednym wywołaniem modelu wyciąga z wątku wszystko, czego potrzebuje kreator procesu: nazwy, dane klienta i kontaktu, opis oraz szkic odpowiedzi. 
     * @param {string} emailThreadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCreationAiSuggestions(emailThreadId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationAiSuggestionsDto>;

    /**
     * Podpowiedzi z maili podpiętych do istniejącego procesu, żeby uzupełnić jego klienta i kontakt. Proces bez podpiętych wątków to kod 400. 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCreationAiSuggestionsForProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationAiSuggestionsDto>;

    /**
     * Te same podpowiedzi co dla wątku mailowego, ale z notatki handlowca — np. z rozmowy telefonicznej, gdy proces nie ma jeszcze maila. Pusta notatka to kod 400. 
     * @param {ProcessCreationAiNoteRequestDto} processCreationAiNoteRequestDto Notatka handlowca, z której AI wyciąga dane klienta, kontaktu i wydarzenia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCreationAiSuggestionsFromNote(processCreationAiNoteRequestDto: ProcessCreationAiNoteRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationAiSuggestionsDto>;

    /**
     * 
     * @param {string} email 
     * @param {string} [emailThreadId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCreationDefaultData(email: string, emailThreadId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationDefaultDataDto>;

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessTodoInfo(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessTodoInfoDto>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessesShortList(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessShortDetailsDto>>;

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProcesses(page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessPageableResponseDto>;

    /**
     * Zwraca procesy, ktorych jestem wlascicielem i pod ktorymi wisi moje otwarte zadanie, wraz z agregatem tych zadan: ile ich jest, jaki jest najblizszy termin i jakich sa rodzajow. Domyslny `scope=DUE` odpowiada 1:1 staremu filtrowi `isNeedingAttention` z `processes-search`, wiec podmiana na pulpicie niczego nie zmienia w doborze wierszy — dokłada tylko informacje, ktorych ten widok wczesniej nie mial.  `summary` liczy sie zawsze na pelnym zbiorze (bez `scope` i `definitions`), zeby liczniki przy filtrach pokazywaly, ile jest do wziecia, a nie ile zostalo po odfiltrowaniu. 
     * @summary Kolejka pracy pulpitu — procesy z moimi otwartymi zadaniami
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} userId 
     * @param {ProcessAttentionScopeDto} [scope] Wycinek terminow. Domyslnie DUE — zaleglosci i dzisiaj, czyli stare zachowanie.
     * @param {Array<TaskDefinitionDto>} [definitions] Zawez do procesow, pod ktorymi wisi zadanie ktoregos z tych rodzajow.
     * @param {ProcessAttentionSortByDto} [sortBy] Domyslnie NEAREST_DUE_DATE rosnaco — najstarsze nieobsluzone na gorze.
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProcessesNeedingAttention(page: number, pageSize: number, userId: string, scope?: ProcessAttentionScopeDto, definitions?: Array<TaskDefinitionDto>, sortBy?: ProcessAttentionSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessAttentionPageableResponseDto>;

    /**
     * 
     * @param {string} processId 
     * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update process\'s status
     * @param {string} processId 
     * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessStatus(processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestProcessesApi - object-oriented interface
 */
export class RestProcessesApi extends BaseAPI implements RestProcessesApiInterface {
    /**
     * Skrót dla obsługi zapytania: zamiast zakładać osobno proces, grupę ofert i ofertę, tworzy wszystkie trzy w jednej transakcji i zwraca gotową ofertę. Gdy podany jest `sourceOfferId`, oferta powstaje jako kopia wskazanego szablonu wraz z całą strukturą; bez niego jest pusta. 
     * @summary Start an inquiry — process, offer group and offer in one call
     * @param {string} userId 
     * @param {CreateInquiryRequestDto} createInquiryRequestDto Klient, termin i liczba gości — reszta domyślna
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInquiry(userId: string, createInquiryRequestDto: CreateInquiryRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).createInquiry(userId, createInquiryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcess(createProcessRequestDto: CreateProcessRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).createProcess(createProcessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcess(processId: string, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcess(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jednym wywołaniem modelu wyciąga z wątku wszystko, czego potrzebuje kreator procesu: nazwy, dane klienta i kontaktu, opis oraz szkic odpowiedzi. 
     * @param {string} emailThreadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCreationAiSuggestions(emailThreadId: string, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessCreationAiSuggestions(emailThreadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Podpowiedzi z maili podpiętych do istniejącego procesu, żeby uzupełnić jego klienta i kontakt. Proces bez podpiętych wątków to kod 400. 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCreationAiSuggestionsForProcess(processId: string, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessCreationAiSuggestionsForProcess(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Te same podpowiedzi co dla wątku mailowego, ale z notatki handlowca — np. z rozmowy telefonicznej, gdy proces nie ma jeszcze maila. Pusta notatka to kod 400. 
     * @param {ProcessCreationAiNoteRequestDto} processCreationAiNoteRequestDto Notatka handlowca, z której AI wyciąga dane klienta, kontaktu i wydarzenia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCreationAiSuggestionsFromNote(processCreationAiNoteRequestDto: ProcessCreationAiNoteRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessCreationAiSuggestionsFromNote(processCreationAiNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} [emailThreadId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCreationDefaultData(email: string, emailThreadId?: string, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessCreationDefaultData(email, emailThreadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessTodoInfo(processId: string, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessTodoInfo(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessesShortList(options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessesShortList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchProcesses(page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).searchProcesses(page, pageSize, processSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca procesy, ktorych jestem wlascicielem i pod ktorymi wisi moje otwarte zadanie, wraz z agregatem tych zadan: ile ich jest, jaki jest najblizszy termin i jakich sa rodzajow. Domyslny `scope=DUE` odpowiada 1:1 staremu filtrowi `isNeedingAttention` z `processes-search`, wiec podmiana na pulpicie niczego nie zmienia w doborze wierszy — dokłada tylko informacje, ktorych ten widok wczesniej nie mial.  `summary` liczy sie zawsze na pelnym zbiorze (bez `scope` i `definitions`), zeby liczniki przy filtrach pokazywaly, ile jest do wziecia, a nie ile zostalo po odfiltrowaniu. 
     * @summary Kolejka pracy pulpitu — procesy z moimi otwartymi zadaniami
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} userId 
     * @param {ProcessAttentionScopeDto} [scope] Wycinek terminow. Domyslnie DUE — zaleglosci i dzisiaj, czyli stare zachowanie.
     * @param {Array<TaskDefinitionDto>} [definitions] Zawez do procesow, pod ktorymi wisi zadanie ktoregos z tych rodzajow.
     * @param {ProcessAttentionSortByDto} [sortBy] Domyslnie NEAREST_DUE_DATE rosnaco — najstarsze nieobsluzone na gorze.
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchProcessesNeedingAttention(page: number, pageSize: number, userId: string, scope?: ProcessAttentionScopeDto, definitions?: Array<TaskDefinitionDto>, sortBy?: ProcessAttentionSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).searchProcessesNeedingAttention(page, pageSize, userId, scope, definitions, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).updateProcess(processId, updateProcessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process\'s status
     * @param {string} processId 
     * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessStatus(processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).updateProcessStatus(processId, updateProcessStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

